/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FuelStatistics,
    FuelStatisticsFromJSON,
    FuelStatisticsFromJSONTyped,
    FuelStatisticsToJSON,
    FuelStatisticsEntry,
    FuelStatisticsEntryFromJSON,
    FuelStatisticsEntryFromJSONTyped,
    FuelStatisticsEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface FuelStatisticsGroup
 */
export interface FuelStatisticsGroup {
    /**
     * 
     * @type {number}
     * @memberof FuelStatisticsGroup
     */
    driverId?: number;
    /**
     * 
     * @type {string}
     * @memberof FuelStatisticsGroup
     */
    monitoredObjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof FuelStatisticsGroup
     */
    dateFrom: string;
    /**
     * 
     * @type {string}
     * @memberof FuelStatisticsGroup
     */
    dateTo: string;
    /**
     * 
     * @type {FuelStatistics}
     * @memberof FuelStatisticsGroup
     */
    stats: FuelStatistics;
    /**
     * 
     * @type {Array<FuelStatisticsEntry>}
     * @memberof FuelStatisticsGroup
     */
    entries?: Array<FuelStatisticsEntry>;
}

export function FuelStatisticsGroupFromJSON(json: any): FuelStatisticsGroup {
    return FuelStatisticsGroupFromJSONTyped(json, false);
}

export function FuelStatisticsGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelStatisticsGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'monitoredObjectId': !exists(json, 'monitored_object_id') ? undefined : json['monitored_object_id'],
        'dateFrom': json['date_from'],
        'dateTo': json['date_to'],
        'stats': FuelStatisticsFromJSON(json['stats']),
        'entries': !exists(json, 'entries') ? undefined : ((json['entries'] as Array<any>).map(FuelStatisticsEntryFromJSON)),
    };
}

export function FuelStatisticsGroupToJSON(value?: FuelStatisticsGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'monitored_object_id': value.monitoredObjectId,
        'date_from': value.dateFrom,
        'date_to': value.dateTo,
        'stats': FuelStatisticsToJSON(value.stats),
        'entries': value.entries === undefined ? undefined : ((value.entries as Array<any>).map(FuelStatisticsEntryToJSON)),
    };
}


